export default {"src":"/_next/static/media/down-arrow-sort.99077165.svg","height":11,"width":10};